export const connectivitytext = {
    iot: "IoT",
    avobbox: "AVOB Energy Box",
    session: "Sessions AVOB Energy Box",
    iotconnectors: "Connecteurs IoT",
    gateways: "Passerelles LoRaWAN",
    virtualsensors: "Capteurs virtuels",
    entities: "Synthèse des sites",
    lorawanthreads: "Threads de controle LoRaWAN",
}

export const entitiestext = {
    id: "Id",
    name: "Nom",
    path: "Chemin",
    criticiy: "Criticité du site",
    connectedequipments : "Equipements connectés",
    connectedmediumequipments : "Equipements utiles connectés",
    connectedhighequipments : "Equipements critiques connectés",
    minbattery: "Batterie min",
    avgbattery: "Batterie moy",
    minsignal : "Signal min",
    avgsignal: "Signal moy",
    mintemp: "T° min",
    avgtemp: "T° moy",
    maxtemp: "T° max",
    alarms: "Alarmes",
    loadingdata: "Chargement en cours. Cela peut prendre quelques minutes, merci de patienter...",
}